module.exports = "/_next/static/images/ConsistentData@2x-da9ab58890cabf662bfcbec3d74559c2.webp";